import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import TablePriceList from './TablePriceList';
import ModalPriceForm from './ModalPriceForm';

const ModalPriceList = ({
  showitem,
  handleCloseMoudal,
  groupId,
  groupTitle,
}) => {
  const [arryactions, setArryactions] = useState([]);

  const [refreshPriceTable, setRefreshPriceTable] = useState(false);

  const [showModalPriceForm, setShowModalPriceForm] = useState(false);

  const handelHideModalPriceForm = () => {
    setShowModalPriceForm(false);
  };

  return (
    <>
      <Modal
        style={{ height: 1000 }}
        show={showitem}
        onHide={handleCloseMoudal}
        size={'lg'}
      >
        <Modal.Header>
          <Modal.Title>لیست قیمت های {groupTitle}</Modal.Title>
          <i
            className='fa fa-times mr-auto'
            style={{ fontSize: '16px', cursor: 'pointer' }}
            onClick={handleCloseMoudal}
            aria-hidden='true'
          ></i>
        </Modal.Header>

        <Modal.Body>
          <Button onClick={() => setShowModalPriceForm(true)} variant='primary'>
            افزودن تعرفه جدید
          </Button>

          <br />

          <TablePriceList
            urldata='/Group/GetPriceList'
            isform
            refreshPriceTable={refreshPriceTable}
            itemname='orderScheduleId'
            params={groupId}
            page='1'
            pageSiz='20'
            arryactions={arryactions}
          />
        </Modal.Body>
      </Modal>

      {showModalPriceForm ? (
        <ModalPriceForm
          showitem={showModalPriceForm}
          refreshPriceTable={() => setRefreshPriceTable(true)}
          handleCloseMoudal={handelHideModalPriceForm}
          groupId={groupId}
        />
      ) : null}
    </>
  );
};

export default ModalPriceList;
